

import React, { useState  } from 'react';
import { Nav,NavDropdown,Container,Row,Col,Button  } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { List  } from 'semantic-ui-react';

import styled from "styled-components";
import DeviceUtils from "../../../helper/DeviceUtils";
 
const HommainView =  styled.div`  
    height:${props => props.height}px;
    position: relative;  
    overflow:hidden;
    color: white;
    margin-left:${props => props.margin}px;
    margin-right: ${props => props.margin}px; 
    `; 
const WRchTxt0 =  styled.div` 
    color: white;
    position: relative;
    margin: ${props => props.marginTop}px  0px 0 0;
    left: 0px;
    grid-area: 3 / 1 / 4 / 2;
    justify-self: start;
    align-self: start;  `;
    
    
const RPWrap =  styled.div` 
position: static;
display: grid;
height: auto;
width: 100%;
min-height: auto;
grid-template-rows: min-content 1fr;
grid-template-columns: 100%;
`; 
const RPIndex =  styled.div` 
position: relative;
margin: 29px 0px 56px 0;
left: 11px;
grid-area: 1 / 1 / 2 / 2;
justify-self: start;
align-self: start;  
font-size: 20px;
color: red;
`;

const RPTitle =  styled.div` 
position: relative;
    margin: 29px 0px 56px 0;
    left: 58px;
    grid-area: 1 / 1 / 2 / 2;
    justify-self: start;
    align-self: start;
font-size: 20px;
color: red;
`;
 
const RPContent =  styled.div` 
position: relative;
    margin: 0px 0px 30px 0;
    left: 11px;
    grid-area: 2 / 1 / 3 / 2;
    justify-self: start;
    align-self: start;
    font-size: 16px; 
    line-height: 1.8em; 
    text-align: justify;
`;


class RightPcontent extends React.Component {
    render() {
      return <RPWrap 
      style={{width:(DeviceUtils.isMobile()===true)?`${window.innerWidth-60}px`:"550px"}}  >
          <RPIndex className="newServicesSubTitle"> 
            {this.props.index} 
          </RPIndex> 
          <RPTitle className="newServicesSubTitle">
            {this.props.title}
          </RPTitle>
          <RPContent>
            {this.props.content} 
          </RPContent>
    
      </RPWrap>;
    }
}

const ServicesCenterView = () => {

    const mainHeight =(DeviceUtils.isMobile()===true)?500:500;

    const onlineWidth = (DeviceUtils.isMobile()===true)?window.innerWidth:(window.innerWidth/2);

    const OnlineLable_phonr_Height = 500;

    const LeaveLable_phonr_Height = 100;

    //桌機
    const pRightMargin = 30;

    return (<HommainView 
        margin={(DeviceUtils.isMobile()===true)?0:100} 
        id={"ServicesCenterView"} 
        style={{width:`${window.innerWidth}px`,paddingTop:`${(DeviceUtils.isMobile()===true)?110:110}px`}}  
        className="position-relative newpageP"   >
  
        <Row className="p-0 m-0"   >
            <Col className="p-0 m-0"   >
                    <WRchTxt0 marginTop={(DeviceUtils.isMobile()===true)?30:40}
                    marginRight={(DeviceUtils.isMobile()===true)?0:pRightMargin}
                    marginLeft={(DeviceUtils.isMobile()===true)?0:(125-pRightMargin)}
                    >
                        {/*{titleArray.map((title,index)=>{*/}
                        {/*    return <H4div  key={index} fontSize={fontSizeNum}>*/}
                        {/*        {title}*/}
                        {/*    </H4div>;*/}
                        {/*})}*/}

                        <h3 className="newpageTitle" 
                        style={{
                            paddingLeft:`${(DeviceUtils.isMobile()===true)?28:0}px`,
                            width:`${(DeviceUtils.isMobile()===true)?window.innerWidth-80:479}px`,
                            fontSize:`${(DeviceUtils.isMobile()===true)?46:56}px`}}>
                       Our Services
                        </h3> 
                        <p  
                        style={{
                            paddingLeft:`${(DeviceUtils.isMobile()===true)?28:0}px`,
                            paddingTop:`${(DeviceUtils.isMobile()===true)?20:40}px`,
                        width:`${(DeviceUtils.isMobile()===true)?window.innerWidth-50:479}px`,
                        fontSize:`${(DeviceUtils.isMobile()===true)?18:18}px`}}>
                            SubPro is a subtitle localization company based in Taipei, Taiwan. We offer subtitling services in more than 60 languages.
                            <br/><br/>
                            We have experience in various kinds of projects, including closed captioning. Such as Subtitles for the Deaf and Hard of Hearing (SDH) and Forced Narrative (FN). Currently, we have decided to take a step forward by sharing our self-produced videos with the world, showing how beautiful our motherland is.
                            <br/><br/>
                            In the future, more video creators will join the campaign – and languages will no longer be the barriers to your amazing work!
                            <br/><br/>
                        </p> 
                    </WRchTxt0>
                </Col>

            <Col>
                    <RightPcontent index={1} title="Platform" content={<p  >
                        We have our own project management system and cloud-based subtitling tool specifically built for subtitling.
                        <br/><br/>
                        The powerful system supports multiple subtitle formats and is able to provide subtitle files based on any requirements.
                        <br/><br/>
                        Our subtitling services include normal sub and closed captions (SDH & FN).
                        </p>} />

                    <RightPcontent index={2} title="Localization" content={<p>
                        Diverse sorts of localization services are provided as follows:​
                        <br/><br/>
                        <li>Subtitling</li> 
                        <p>
                            Timed text creation/conformance<br/> 
                            Closed caption creation/conformance<br/> 
                            Fast track service
                        </p> 
                        <li>Dubbing</li>
                        <p>
                            Dubbing<br/> 
                            Voice over<br/> 
                            Lectoring<br/> 
                            Dubbing script creation/conformance
                        </p>  
                    </p>} />

                    <RightPcontent index={3} title="Languages" content={<p >
                        Services are provided in more than 60 languages by linguists around the world. Contact us for more information.
                    </p>} /> 
                               
                    <RightPcontent index={4} title="Independent film Salon" content={<p >
                        A brand new film salon has been founded by SubPro Studio. We aim to support producers with our professional subtitling services, providing the audience with more possibilities to watch films in their familiar languages.
                        <br/><br/>
                        As a professional company in the industry, satisfying people’s needs in knowledge, entertainment, and imagination has always been our core value. It is our goal to deliver precise and meaningful messages for the audience.
                    </p>} />          
                    
                </Col>

         </Row>
    </HommainView>);
};

export default ServicesCenterView;



// WEBPACK FOOTER //
// ./src/components/homepage_new/services/ServicesCenterView.js